import ServiceHelper from "../../../helpers/service-helper";

const queryString = `
query Search($searchTerm: String!, $locale: [Locales], $siteId: String!, $ranking: Ranking!) {
  ArticlePage(
    limit: 20
    locale: $locale
    where: {
      _fulltext: { match: $searchTerm }
      Name: { match: $searchTerm, boost: 20 }
      SiteId: { eq: $siteId }
      IsSchemaData: { notEq: true }
      ExcludePageFromSearch: { notEq: true }
    }
    orderBy: { _ranking: $ranking}
  ) {
    total
    items {
      _score
      Name
      RelativePath
      _fulltext
    }
  }
  LandingPage(
    limit: 20
    locale: $locale
    where: {
      _fulltext: { match: $searchTerm }
      Name: { match: $searchTerm, boost: 20 }
      SiteId: { eq: $siteId }
      IsSchemaData: { notEq: true }
      ExcludePageFromSearch: { notEq: true }
    }
    orderBy: { _ranking: $ranking}
  ) {
    total
    items {
      _score
      Name
      RelativePath
      _fulltext
    }
  }
  NewsPage(
    limit: 20
    locale: $locale
    where: {
      _fulltext: { match: $searchTerm }
      Name: { match: $searchTerm, boost: 20 }
      SiteId: { eq: $siteId }
      IsSchemaData: { notEq: true }
      ExcludePageFromSearch: { notEq: true }
    }
    orderBy: { _ranking: $ranking}
  ) {
    total
    items {
      _score
      Name
      RelativePath
      _fulltext
    }
  }
  CisionNewsPage(
    limit: 20
    locale: $locale
    where: {
      _fulltext: { match: $searchTerm }
      Name: { match: $searchTerm, boost: 20 }
      SiteId: { eq: $siteId }
      IsSchemaData: { notEq: true }
      ExcludePageFromSearch: { notEq: true }
    }
    orderBy: { _ranking: $ranking}
  ) {
    total
    items {
      _score
      Name
      RelativePath
      _fulltext
    }
  }
}
`;

export const postSearchTerm = async (
  searchTerm: string,
  locale: string,
  siteId: string,
  ranking: "SEMANTIC" | "RELEVANCE" = "SEMANTIC",
) => {
  const body = JSON.stringify({
    query: queryString,
    variables: {
      searchTerm: searchTerm,
      locale: locale,
      siteId: siteId,
      ranking: ranking,
    },
  });

  return ServiceHelper.httpPost("/integrations/api/v1/cms/query", {
    body,
    headers: { "Content-Type": "application/json" },
  });
};
